import { 
  collection, 
  addDoc, 
  getDocs, 
  deleteDoc, 
  doc, 
  query, 
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';
import { 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  deleteObject 
} from 'firebase/storage';
import { db, storage } from '../firebaseConfig';

const GALLERY_COLLECTION = 'gallery';

/**
 * Get all gallery images
 */
export const getGalleryImages = async () => {
  try {
    const q = query(
      collection(db, GALLERY_COLLECTION),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    const images = [];
    querySnapshot.forEach((doc) => {
      images.push({ id: doc.id, ...doc.data() });
    });
    return images;
  } catch (error) {
    console.error('Error fetching gallery images:', error);
    throw error;
  }
};

/**
 * Upload a new gallery image
 * @param {File} file - The image file to upload
 * @param {string} caption - Optional caption for the image
 * @param {string} uploadedBy - User ID of the uploader
 */
export const uploadGalleryImage = async (file, caption = '', uploadedBy) => {
  try {
    // Upload image to Firebase Storage
    const timestamp = Date.now();
    const fileName = `gallery/${timestamp}_${file.name}`;
    const storageRef = ref(storage, fileName);
    
    await uploadBytes(storageRef, file);
    const imageUrl = await getDownloadURL(storageRef);

    // Add image metadata to Firestore
    const galleryData = {
      imageUrl,
      storagePath: fileName,
      caption: caption || '',
      uploadedBy,
      createdAt: serverTimestamp()
    };

    const docRef = await addDoc(collection(db, GALLERY_COLLECTION), galleryData);
    
    return { id: docRef.id, ...galleryData };
  } catch (error) {
    console.error('Error uploading gallery image:', error);
    throw error;
  }
};

/**
 * Delete a gallery image
 * @param {string} imageId - The ID of the image to delete
 * @param {string} storagePath - The storage path of the image
 */
export const deleteGalleryImage = async (imageId, storagePath) => {
  try {
    // Delete from Storage
    if (storagePath) {
      const storageRef = ref(storage, storagePath);
      await deleteObject(storageRef);
    }

    // Delete from Firestore
    await deleteDoc(doc(db, GALLERY_COLLECTION, imageId));
    
    return true;
  } catch (error) {
    console.error('Error deleting gallery image:', error);
    throw error;
  }
};
